<template>
  <template v-if="$page && $beet.isReady">
    <section
      :class="['section header --home', { '--ad': $beet?.ads?.site?.home.header?.length ?? false }]"
    >
      <div class="header__section">
        <h1 class="header__title" v-reveal>{{ $page.header.title }}</h1>
        <p class="header__p" v-reveal="{ delay: 200 }">{{ $page.header.description }}</p>
        <div class="header__buttons">
          <LangRouterLink :to="{ name: 'about' }" class="button -right" v-reveal="{ delay: 200 }">
            {{ $page.header.about_btn }}
            <span class="button__icon">
              <Icon id="arrow" />
            </span>
          </LangRouterLink>

          <LangRouterLink
            :to="{ name: 'voyages' }"
            class="button -right -light"
            v-reveal="{ delay: 200 }"
          >
            {{ $page.header.destinations_btn }}
            <span class="button__icon">
              <Icon id="arrow" />
            </span>
          </LangRouterLink>
        </div>
      </div>

      <div class="header__section">
        <template v-for="(card, index) in cards" :key="index">
          <LangRouterLink
            v-if="card.type === 'destination' && card.destination"
            :to="{ name: 'voyage', params: { slug: card.destination.slug } }"
            :class="['header__card', { header__gradient: index === 0 }]"
            :style="{
              backgroundImage: `
              linear-gradient(to left, #0d294b75 40%, transparent),
              url(${card.destination.cover_id?.lg || card.destination.map_id?.lg})
            `,
            }"
            v-reveal="{ delay: index * 250 }"
          >
            <div>
              <div class="flex-row -end">
                <Icon id="destination" class="header__card-destination" />
                {{ card.destination.name }}
              </div>

              <div>{{ getZoneName(card.destination) }}</div>

              <div class="header__card-link">
                <Icon id="arrow" />
              </div>
            </div>

            <div
              v-if="index === 1 && $page.header.youtube"
              @click.prevent="showVideo = true"
              class="header__card-video"
            >
              <span>{{ $t('play_snippet') }}</span>
              <Icon id="play" />
            </div>
          </LangRouterLink>

          <LangRouterLink
            v-else-if="card.type === 'content'"
            :to="{ name: card.link }"
            :class="['header__card', { header__gradient: index === 0 }]"
            :style="{
              backgroundImage: `
                linear-gradient(to left, #0d294b75 40%, transparent),
                url(${card.image?.lg})
              `,
            }"
            v-reveal="{ delay: index * 250 }"
          >
            <div>
              <div class="header__card-text max-w-md">
                {{ card.text }}
              </div>
              <div class="header__card-link">
                <Icon id="arrow" />
              </div>
            </div>

            <div
              v-if="index === 1 && $page.header.youtube"
              @click.prevent="showVideo = true"
              class="header__card-video"
            >
              <span>{{ $t('play_snippet') }}</span>
              <Icon id="play" />
            </div>
          </LangRouterLink>
        </template>
      </div>

      <AdBanner :ads="$beet?.ads?.site?.home.header ?? []" no-section class="--home" />
    </section>

    <PageBuilder :sections="$page.sections" />

    <AdBanner :ads="$beet?.ads?.site?.home.footer ?? []" />

    <transition name="fade" appear>
      <Video v-if="showVideo" @close="showVideo = false" :youtubeId="youtubeId" />
    </transition>
  </template>

  <template v-else>
    <Loader />
  </template>
</template>

<script>
import Loader from '@/components/blocks/Loader.vue'
import Video from '@/components/blocks/Video.vue'
import Icon from '@/components/global/Icon.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'
import PageBuilder from '@/components/PageBuilder.vue'
import AdBanner from '@/components/sections/AdBanner.vue'
import { setMeta } from '@/helpers/metaHelpers'

export default {
  name: 'Home',
  beetPage: 'accueil',
  components: {
    AdBanner,
    Icon,
    LangRouterLink,
    Video,
    Loader,
    PageBuilder,
  },
  data() {
    return {
      open: true,
      showVideo: false,
    }
  },
  beforeMount() {
    if (this.$page) setMeta(this.$page.seo)
  },
  watch: {
    $page(to) {
      setMeta(to.seo)
    },
  },
  computed: {
    cards() {
      const header = this.$page?.header

      if (!header) return []

      return [1, 2].map((number) => {
        const type = header[`card_${number}_type`]

        if (type === 'destination') {
          const destination = Object.values(this.$beet.destinations || {}).find(
            (item) => item.id === Number(header[`card_${number}_destination`]),
          )

          return {
            type,
            destination,
          }
        }

        return {
          type,
          text: header[`card_${number}_text`],
          image: header[`card_${number}_image`],
          link: header[`card_${number}_link`],
        }
      })
    },
    youtubeId() {
      if (!this.$page.header?.youtube) return null
      return this.$page.header.youtube.substr(
        this.$page.header.youtube.lastIndexOf('/') + 1,
        this.$page.header.youtube.length,
      )
    },
  },
  methods: {
    getZoneName(voyage) {
      if (voyage.zone_id) {
        return this.$beet.destinations_zones[Number(voyage.zone_id)]?.name
      }
      return voyage.identifier
    },
  },
}
</script>
